import { useLayoutEffect, useRef } from 'react';

type FYIGroupCategoryProps = {
    groupName: string;
    groupIndex: number;
    onSizeChange: (index: number, size?: number) => void;
};

function FYIGroupCategory({ groupName, groupIndex, onSizeChange }: FYIGroupCategoryProps): JSX.Element {
    const ref = useRef<HTMLLIElement>(null);

    useLayoutEffect(() => {
        onSizeChange(groupIndex, ref.current?.offsetHeight);
    }, []);

    return (
        <li className="list-none" ref={ref}>
            <p className="text-sm leading-8 font-medium">{groupName}</p>
        </li>
    );
}

export default FYIGroupCategory;
